import i18n from '@yandex-int/i18n';
import { IMenuMobileItem } from 'client/blocks/MenuMobile/MenuMobile';
import { routes } from 'client/lib/routes';
import { Skill } from 'client/model/skill';
import * as keyset from 'i18n/AppsIndex';

import { useSettingsPageMenuItems } from './useSettingsPageMenuItems';
import { useSkillPageMenuItems } from './useSkillPageMenuItems';

const t = i18n(keyset);

interface ISkillMenu {
    skill: Skill;
    isDraft: boolean;
}

export const useSkillMenu = ({ skill, isDraft }: ISkillMenu) => {
    const { menuItems: skillPageMenuItems, display: displaySkillMenu } = useSkillPageMenuItems(skill);
    const displayMenuForDraft = !skill.onAir || isDraft;
    const { menuItems: settingsPageMenuItems, display: displaySettingsMenu } = useSettingsPageMenuItems(
        skill,
        displayMenuForDraft,
    );

    const settingRoute = routes.app.skillSettings(displayMenuForDraft, 'main', skill.id);
    const menuItems: IMenuMobileItem[] = [
        {
            value: settingRoute,
            content: t('main-information'),
            items: [
                ...settingsPageMenuItems
                    .filter((menuItem) => !!displaySettingsMenu[menuItem.tab])
                    .map((menuItem) => ({ value: menuItem.path, content: menuItem.title })),
            ],
        },
        ...skillPageMenuItems
            .filter((menuItem) => !!displaySkillMenu[menuItem.tab])
            .map((menuItem) => ({ value: menuItem.path, content: menuItem.title })),
    ];

    return { menuItems, displaySkillMenu, displaySettingsMenu };
};
